<template>
  <div>
    <transition name="el-fade-in-linear">
      <div class="main_wrap" v-show="shown.mainshow">
        <div class="commonhead">
          <com-head></com-head>
        </div>
        <div class="head_wrap"></div>
        <div class="body_wrap">
          <div class="menu_tabs">
            <el-tabs
              tab-position="left"
              style="height: 100%"
              value="1"
              @tab-click="clickTabs"
            >
              <el-tab-pane
                :label="$t('App.page.center.tab_info')"
                class="tab_basic_info"
                name="1"
              >
                <div class="info_content">
                  <div class="password_content">
                    <el-button
                      size="mini"
                      type="success"
                      @click="resetPassword"
                      >{{ $t("App.page.center.btn_resetpassword") }}</el-button
                    >
                  </div>
                  <div class="basic_content">
                    <el-form
                      :model="formData.basicInfo"
                      ref="form_basicInfo"
                      class="form_basicInfo"
                      size="mini"
                    >
                      <el-alert
                        :title="this.$t('App.page.center.alert_ccemail')"
                        type="success"
                        :closable="false"
                        style="margin-bottom: 1rem"
                        show-icon
                      >
                      </el-alert>

                      <el-form-item
                        :label="this.$t('App.view.customer.label_add_email')"
                      >
                        <el-tooltip
                          effect="dark"
                          :content="$t('App.page.center.tooltip_email')"
                          placement="top"
                        >
                          <el-input
                            v-model="formData.basicInfo.email"
                            maxlength="100"
                            show-word-limit
                            size="mini"
                            :placeholder="$t('App.text.placeholder')"
                          ></el-input>
                        </el-tooltip>
                      </el-form-item>

                      <el-form-item
                        :label="this.$t('App.page.center.label_ccemail')"
                      >
                        <el-input
                          v-model="formData.basicInfo.cc_email.email1"
                          maxlength="100"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        :label="this.$t('App.page.center.label_ccemail')"
                      >
                        <el-input
                          v-model="formData.basicInfo.cc_email.email2"
                          maxlength="100"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        :label="this.$t('App.page.center.label_ccemail')"
                      >
                        <el-input
                          v-model="formData.basicInfo.cc_email.email3"
                          maxlength="100"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        :label="this.$t('App.page.center.label_ccemail')"
                      >
                        <el-input
                          v-model="formData.basicInfo.cc_email.email4"
                          maxlength="100"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        :label="this.$t('App.page.center.label_ccemail')"
                      >
                        <el-input
                          v-model="formData.basicInfo.cc_email.email5"
                          maxlength="100"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>

                      <el-form-item>
                        <el-button
                          type="success"
                          size="mini"
                          @click="useJsDoModifyBasic('form_basicInfo')"
                          class="modifyBasicBtn"
                          >{{ $t("App.page.center.btn_save") }}</el-button
                        ></el-form-item
                      >
                    </el-form>
                  </div>
                  <div class="info_dialog_content">
                    <div class="password_reset_dialog">
                      <el-dialog
                        width="30%"
                        ref="resetPassword_Dialog"
                        :modal="true"
                        :close-on-click-modal="false"
                        :close-on-press-escape="false"
                        :center="true"
                        :title="this.$t('App.page.center.title_reset_password')"
                        :visible.sync="pageData.resetPasswordDialogVisible"
                      >
                        <el-form
                          :model="formData.passwordForm"
                          ref="form_password"
                          class="form_password"
                          size="mini"
                        >
                          <el-form-item
                            :label="this.$t('App.page.center.label_newpass')"
                          >
                            <el-input
                              v-model="formData.passwordForm.password"
                              maxlength="15"
                              show-word-limit
                              show-password
                              size="mini"
                            ></el-input>
                          </el-form-item>

                          <el-form-item>
                            <el-button
                              type="success"
                              size="mini"
                              @click="useJsDoResetPass('form_password')"
                              class="resetPassBtn"
                              >{{ $t("App.page.center.btn_save") }}</el-button
                            ></el-form-item
                          >
                        </el-form>
                      </el-dialog>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane
                :label="$t('App.page.center.tab_order')"
                class="tab_order_list"
                name="2"
              >
                <div class="order_list_content">
                  <div class="radio_group_orderlist">
                    <el-radio-group
                      v-model="pageData.orderListDisplay"
                      @change="switchOrderList"
                      size="mini"
                    >
                      <el-radio-button :label="1"
                        >{{
                          $t("App.page.center.radio_orderlist_all")
                        }}&nbsp;({{
                          pageData.listOrders.length
                        }})</el-radio-button
                      >
                      <el-radio-button :label="2"
                        >{{
                          $t("App.page.center.radio_orderlist_processing")
                        }}&nbsp;({{
                          pageData.listOrders_processing.length
                        }})</el-radio-button
                      >
                      <el-radio-button :label="3"
                        >{{
                          $t("App.page.center.radio_orderlist_finished")
                        }}&nbsp;({{
                          pageData.listOrders_finished.length
                        }})</el-radio-button
                      >
                    </el-radio-group>
                  </div>
                  <div class="order_list_class_content">
                    <div
                      class="order_list_all"
                      v-show="pageData.orderListDisplay === 1"
                    >
                      <div class="search_content">
                        <el-input
                          size="mini"
                          show-word-limit
                          maxlength="20"
                          v-model="pageData.searchContent"
                          clearable
                        >
                          <el-button
                            @click="searchOrderAll"
                            slot="append"
                            icon="el-icon-search"
                          ></el-button
                        ></el-input>
                      </div>
                      <div class="card_content">
                        <div
                          v-for="(order, index) in pageData.listOrders"
                          :key="index"
                          :index="index"
                        >
                          <el-card
                            shadow="hover"
                            class="card_order_finished"
                            v-if="order.orderstatus_id == 'OT0000000007'"
                          >
                            <div class="card_body_content">
                              <el-row
                                >{{ $t("App.page.center.label_order_number")
                                }}{{ order.id }}
                                <el-tooltip
                                  class="item"
                                  effect="dark"
                                  :content="$t('App.text.clicktocopy')"
                                  placement="bottom"
                                >
                                  <el-button
                                    icon="el-icon-copy-document"
                                    type="primary"
                                    circle
                                    plain
                                    size="mini"
                                    v-clipboard:copy="order.id"
                                    v-clipboard:success="copySuccess"
                                  ></el-button>
                                </el-tooltip>
                              </el-row>
                              <br />
                              <el-row
                                >{{ $t("App.page.center.label_order_fid")
                                }}{{ order.fid }}
                                <el-tooltip
                                  class="item"
                                  effect="dark"
                                  :content="$t('App.text.clicktocopy')"
                                  placement="bottom"
                                >
                                  <el-button
                                    icon="el-icon-copy-document"
                                    type="primary"
                                    circle
                                    plain
                                    size="mini"
                                    v-clipboard:copy="order.fid"
                                    v-clipboard:success="copySuccess"
                                  ></el-button>
                                </el-tooltip>
                              </el-row>
                              <br />
                              <el-row
                                >{{ $t("App.page.center.label_order_custpo")
                                }}{{ order.cust_po }}
                                <el-tooltip
                                  class="item"
                                  effect="dark"
                                  :content="$t('App.text.clicktocopy')"
                                  placement="bottom"
                                >
                                  <el-button
                                    icon="el-icon-copy-document"
                                    type="primary"
                                    circle
                                    plain
                                    size="mini"
                                    v-clipboard:copy="order.cust_po"
                                    v-clipboard:success="copySuccess"
                                  ></el-button>
                                </el-tooltip>
                              </el-row>
                              <br />
                              <el-row
                                >{{
                                  $t("App.page.center.label_order_createtime")
                                }}{{ order.create_time
                                }}<span style="color: #fff">
                                  ({{ $t("App.text.utc+8") }})</span
                                ></el-row
                              >
                            </div>
                            <div class="card_suffix_content">
                              <el-button
                                type="success"
                                circle
                                size="mini"
                                plain
                                icon="el-icon-right"
                                @click="toOrderform(order)"
                              ></el-button>
                            </div>
                          </el-card>
                          <el-card
                            shadow="hover"
                            class="card_order_processing"
                            v-else
                          >
                            <div class="card_body_content">
                              <el-row
                                >{{ $t("App.page.center.label_order_number")
                                }}{{ order.id }}
                                <el-tooltip
                                  class="item"
                                  effect="dark"
                                  :content="$t('App.text.clicktocopy')"
                                  placement="bottom"
                                >
                                  <el-button
                                    icon="el-icon-copy-document"
                                    type="primary"
                                    circle
                                    plain
                                    size="mini"
                                    v-clipboard:copy="order.id"
                                    v-clipboard:success="copySuccess"
                                  ></el-button>
                                </el-tooltip>
                              </el-row>
                              <br />
                              <el-row
                                >{{ $t("App.page.center.label_order_fid")
                                }}{{ order.fid }}
                                <el-tooltip
                                  class="item"
                                  effect="dark"
                                  :content="$t('App.text.clicktocopy')"
                                  placement="bottom"
                                >
                                  <el-button
                                    icon="el-icon-copy-document"
                                    type="primary"
                                    circle
                                    plain
                                    size="mini"
                                    v-clipboard:copy="order.fid"
                                    v-clipboard:success="copySuccess"
                                  ></el-button>
                                </el-tooltip>
                              </el-row>
                              <br />
                              <el-row
                                >{{ $t("App.page.center.label_order_custpo")
                                }}{{ order.cust_po }}
                                <el-tooltip
                                  class="item"
                                  effect="dark"
                                  :content="$t('App.text.clicktocopy')"
                                  placement="bottom"
                                >
                                  <el-button
                                    icon="el-icon-copy-document"
                                    type="primary"
                                    circle
                                    plain
                                    size="mini"
                                    v-clipboard:copy="order.cust_po"
                                    v-clipboard:success="copySuccess"
                                  ></el-button>
                                </el-tooltip>
                              </el-row>
                              <br />
                              <el-row
                                >{{
                                  $t("App.page.center.label_order_createtime")
                                }}{{ order.create_time
                                }}<span style="color: #fff">
                                  ({{ $t("App.text.utc+8") }})</span
                                ></el-row
                              >
                            </div>
                            <div class="card_suffix_content">
                              <el-button
                                type="primary"
                                circle
                                plain
                                size="mini"
                                icon="el-icon-right"
                                @click="toOrderform(order)"
                              ></el-button>
                            </div>
                          </el-card>
                        </div>
                      </div>
                    </div>
                    <div
                      class="order_list_processing"
                      v-show="pageData.orderListDisplay === 2"
                    >
                      <el-card
                        v-for="(order, index) in pageData.listOrders_processing"
                        :key="index"
                        :index="index"
                        shadow="hover"
                        class="card_order_processing"
                      >
                        <div class="card_body_content">
                          <el-row
                            >{{ $t("App.page.center.label_order_number")
                            }}{{ order.id }}
                            <el-tooltip
                              class="item"
                              effect="dark"
                              :content="$t('App.text.clicktocopy')"
                              placement="bottom"
                            >
                              <el-button
                                icon="el-icon-copy-document"
                                type="primary"
                                circle
                                plain
                                size="mini"
                                v-clipboard:copy="order.id"
                                v-clipboard:success="copySuccess"
                              ></el-button>
                            </el-tooltip>
                          </el-row>
                          <br />
                          <el-row
                            >{{ $t("App.page.center.label_order_fid")
                            }}{{ order.fid }}
                            <el-tooltip
                              class="item"
                              effect="dark"
                              :content="$t('App.text.clicktocopy')"
                              placement="bottom"
                            >
                              <el-button
                                icon="el-icon-copy-document"
                                type="primary"
                                circle
                                plain
                                size="mini"
                                v-clipboard:copy="order.fid"
                                v-clipboard:success="copySuccess"
                              ></el-button>
                            </el-tooltip>
                          </el-row>
                          <br />
                          <el-row
                            >{{ $t("App.page.center.label_order_custpo")
                            }}{{ order.cust_po }}
                            <el-tooltip
                              class="item"
                              effect="dark"
                              :content="$t('App.text.clicktocopy')"
                              placement="bottom"
                            >
                              <el-button
                                icon="el-icon-copy-document"
                                type="primary"
                                circle
                                plain
                                size="mini"
                                v-clipboard:copy="order.cust_po"
                                v-clipboard:success="copySuccess"
                              ></el-button>
                            </el-tooltip>
                          </el-row>
                          <br />
                          <el-row
                            >{{ $t("App.page.center.label_order_createtime")
                            }}{{ order.create_time
                            }}<span style="color: #fff">
                              ({{ $t("App.text.utc+8") }})</span
                            ></el-row
                          >
                        </div>
                        <div class="card_suffix_content">
                          <el-button
                            type="primary"
                            circle
                            plain
                            size="mini"
                            icon="el-icon-right"
                            @click="toOrderform(order)"
                          ></el-button>
                        </div>
                      </el-card>
                    </div>
                    <div
                      class="order_list_finished"
                      v-show="pageData.orderListDisplay === 3"
                    >
                      <el-card
                        v-for="(order, index) in pageData.listOrders_finished"
                        :key="index"
                        :index="index"
                        shadow="hover"
                        class="card_order_finished"
                      >
                        <div class="card_body_content">
                          <el-row
                            >{{ $t("App.page.center.label_order_number")
                            }}{{ order.id }}
                            <el-tooltip
                              class="item"
                              effect="dark"
                              :content="$t('App.text.clicktocopy')"
                              placement="bottom"
                            >
                              <el-button
                                icon="el-icon-copy-document"
                                type="primary"
                                circle
                                plain
                                size="mini"
                                v-clipboard:copy="order.id"
                                v-clipboard:success="copySuccess"
                              ></el-button>
                            </el-tooltip>
                          </el-row>
                          <br />
                          <el-row
                            >{{ $t("App.page.center.label_order_fid")
                            }}{{ order.fid }}
                            <el-tooltip
                              class="item"
                              effect="dark"
                              :content="$t('App.text.clicktocopy')"
                              placement="bottom"
                            >
                              <el-button
                                icon="el-icon-copy-document"
                                type="primary"
                                circle
                                plain
                                size="mini"
                                v-clipboard:copy="order.fid"
                                v-clipboard:success="copySuccess"
                              ></el-button>
                            </el-tooltip>
                          </el-row>
                          <br />
                          <el-row
                            >{{ $t("App.page.center.label_order_custpo")
                            }}{{ order.cust_po }}
                            <el-tooltip
                              class="item"
                              effect="dark"
                              :content="$t('App.text.clicktocopy')"
                              placement="bottom"
                            >
                              <el-button
                                icon="el-icon-copy-document"
                                type="primary"
                                circle
                                plain
                                size="mini"
                                v-clipboard:copy="order.cust_po"
                                v-clipboard:success="copySuccess"
                              ></el-button>
                            </el-tooltip>
                          </el-row>
                          <br />
                          <el-row
                            >{{ $t("App.page.center.label_order_createtime")
                            }}{{ order.create_time
                            }}<span style="color: #fff">
                              ({{ $t("App.text.utc+8") }})</span
                            ></el-row
                          >
                        </div>
                        <div class="card_suffix_content">
                          <el-button
                            type="primary"
                            circle
                            plain
                            size="mini"
                            icon="el-icon-right"
                            @click="toOrderform(order)"
                          ></el-button>
                        </div>
                      </el-card>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane
                :label="$t('App.page.center.tab_shipping')"
                class="tab_shipping"
                name="3"
              >
                <div class="new_address">
                  <el-button
                    type="success"
                    circle
                    size="mini"
                    icon="el-icon-plus"
                    @click="addShipping"
                  ></el-button>
                </div>

                <div class="shipping_dialog_content">
                  <el-dialog
                    width="30%"
                    ref="addShipping_Dialog"
                    :modal="true"
                    :close-on-click-modal="false"
                    :close-on-press-escape="false"
                    :center="true"
                    :title="this.$t('App.view.customer.title_add_address')"
                    :visible.sync="pageData.addShippingDialogVisible"
                  >
                    <el-form
                      :model="formData.newShipping"
                      ref="form_newShipping"
                      class="form_newShipping"
                      size="mini"
                    >
                      <el-form-item
                        :label="this.$t('App.view.customer.label_country')"
                      >
                        <el-col>
                          <el-select
                            v-model="formData.newShipping.country"
                            filterable
                            size="small"
                            style="width: 100%"
                            :placeholder="$t('App.text.placeholder_select')"
                          >
                            <div v-if="pageData.lang == 'cn'">
                              <el-option
                                v-for="(item, index) in pageData.countryList"
                                :key="index"
                                :label="item.name_cn"
                                :value="item.id"
                              ></el-option>
                            </div>
                            <div v-else>
                              <el-option
                                v-for="(item, index) in pageData.countryList"
                                :key="index"
                                :label="item.name_en"
                                :value="item.id"
                              ></el-option>
                            </div>
                          </el-select>
                        </el-col>
                      </el-form-item>

                      <el-form-item
                        :label="this.$t('App.view.customer.label_province')"
                      >
                        <el-input
                          v-model="formData.newShipping.province"
                          maxlength="20"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        :label="this.$t('App.view.customer.label_city')"
                      >
                        <el-input
                          v-model="formData.newShipping.city"
                          maxlength="50"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        :label="this.$t('App.view.customer.label_address')"
                      >
                        <el-input
                          v-model="formData.newShipping.address"
                          maxlength="50"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        :label="this.$t('App.view.customer.label_zipcode')"
                      >
                        <el-input
                          v-model="formData.newShipping.zipcode"
                          maxlength="50"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        :label="this.$t('App.view.customer.label_contacts')"
                      >
                        <el-input
                          v-model="formData.newShipping.contacts"
                          maxlength="30"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        :label="this.$t('App.view.customer.label_company')"
                      >
                        <el-input
                          v-model="formData.newShipping.company"
                          maxlength="100"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        :label="this.$t('App.view.customer.label_add_tel')"
                      >
                        <el-input
                          v-model="formData.newShipping.tel"
                          maxlength="30"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        :label="this.$t('App.view.customer.label_add_email')"
                      >
                        <el-input
                          v-model="formData.newShipping.email"
                          maxlength="100"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        :label="this.$t('App.view.customer.label_tag')"
                      >
                        <el-input
                          v-model="formData.newShipping.tag"
                          maxlength="13"
                          show-word-limit
                          size="mini"
                          :placeholder="
                            $t('App.text.placeholder_tag_shippingadd')
                          "
                        ></el-input>
                      </el-form-item>

                      <el-form-item>
                        <el-button
                          class="addAddressBtn"
                          type="success"
                          size="mini"
                          @click="useJsDoNewShipping(formData.newShipping)"
                        >
                          {{ $t("App.view.customer.btn_save") }}</el-button
                        >
                      </el-form-item>
                    </el-form>
                  </el-dialog>

                  <el-dialog
                    width="30%"
                    ref="editShipping_Dialog"
                    :modal="true"
                    :close-on-click-modal="false"
                    :close-on-press-escape="false"
                    :center="true"
                    :title="this.$t('App.view.customer.title_edit_address')"
                    :visible.sync="pageData.editShippingDialogVisible"
                  >
                    <el-form
                      :model="formData.editShipping"
                      ref="form_editShipping"
                      class="form_editShipping"
                      size="mini"
                    >
                      <el-form-item
                        :label="this.$t('App.view.customer.label_country')"
                      >
                        <el-col>
                          <el-select
                            v-model="formData.editShipping.country"
                            filterable
                            size="small"
                            style="width: 100%"
                            :placeholder="$t('App.text.placeholder_select')"
                          >
                            <div v-if="pageData.lang == 'cn'">
                              <el-option
                                v-for="(item, index) in pageData.countryList"
                                :key="index"
                                :label="item.name_cn"
                                :value="item.id"
                              ></el-option>
                            </div>
                            <div v-else>
                              <el-option
                                v-for="(item, index) in pageData.countryList"
                                :key="index"
                                :label="item.name_en"
                                :value="item.id"
                              ></el-option>
                            </div>
                          </el-select>
                        </el-col>
                      </el-form-item>

                      <el-form-item
                        :label="this.$t('App.view.customer.label_province')"
                      >
                        <el-input
                          v-model="formData.editShipping.province"
                          maxlength="20"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        :label="this.$t('App.view.customer.label_city')"
                      >
                        <el-input
                          v-model="formData.editShipping.city"
                          maxlength="50"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        :label="this.$t('App.view.customer.label_address')"
                      >
                        <el-input
                          v-model="formData.editShipping.address"
                          maxlength="50"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        :label="this.$t('App.view.customer.label_zipcode')"
                      >
                        <el-input
                          v-model="formData.editShipping.zipcode"
                          maxlength="50"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        :label="this.$t('App.view.customer.label_contacts')"
                      >
                        <el-input
                          v-model="formData.editShipping.contacts"
                          maxlength="30"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        :label="this.$t('App.view.customer.label_company')"
                      >
                        <el-input
                          v-model="formData.editShipping.company"
                          maxlength="100"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        :label="this.$t('App.view.customer.label_add_tel')"
                      >
                        <el-input
                          v-model="formData.editShipping.tel"
                          maxlength="30"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        :label="this.$t('App.view.customer.label_add_email')"
                      >
                        <el-input
                          v-model="formData.editShipping.email"
                          maxlength="100"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        :label="this.$t('App.view.customer.label_tag')"
                      >
                        <el-input
                          v-model="formData.editShipping.tag"
                          maxlength="13"
                          show-word-limit
                          size="mini"
                          :placeholder="
                            $t('App.text.placeholder_tag_shippingadd')
                          "
                        ></el-input>
                      </el-form-item>

                      <el-form-item>
                        <el-button
                          class="addAddressBtn"
                          type="success"
                          size="mini"
                          @click="useJsDoEditShipping(formData.editShipping)"
                          :loading="pageData.doEditShippingLoad"
                        >
                          {{ $t("App.view.customer.btn_save") }}</el-button
                        >
                      </el-form-item>
                    </el-form>
                  </el-dialog>
                </div>

                <div v-if="pageData.shippingList.length > 0">
                  <div
                    v-for="(address, index) in pageData.shippingList"
                    :key="index"
                    class="div_address"
                  >
                    <el-button
                      circle
                      type="danger"
                      class="el-icon-minus"
                      size="mini"
                      @click="useJsDeleteShipping(address)"
                    ></el-button>
                    <el-button
                      circle
                      type="primary"
                      class="el-icon-edit"
                      size="mini"
                      @click="editShipping(address)"
                    ></el-button>
                    &nbsp;&nbsp;&nbsp;
                    <el-tag
                      size="medium"
                      type="success"
                      effect="dark"
                      :hit="true"
                      >{{ address.tag }}</el-tag
                    >
                    {{
                      address.contacts +
                      ", " +
                      address.email +
                      ", " +
                      address.tel +
                      ", " +
                      address.address +
                      ", " +
                      address.city +
                      ", " +
                      address.province +
                      ", " +
                      address.zipcode
                    }}
                  </div>
                </div>
                <div v-else style="text-align: center; margin-top: 3rem">
                  <i class="el-icon-folder-opened" style="font-size: 4rem"></i>
                  <el-col
                    style="
                      margin-top: 1.5rem;
                      font-size: 1.3rem;
                      margin-bottom: 2rem;
                      color: #606266;
                    "
                    >{{ this.$t("App.page.center.empty_address") }}</el-col
                  >
                </div>
              </el-tab-pane>
              <el-tab-pane
                :label="$t('App.page.center.tab_receipt')"
                class="tab_proforma"
                name="4"
              >
                <div class="new_address">
                  <el-button
                    type="success"
                    circle
                    size="mini"
                    icon="el-icon-plus"
                    @click="addReceipt"
                  ></el-button>
                </div>

                <div class="receipt_dialog_content">
                  <el-dialog
                    width="30%"
                    ref="addReceipt_Dialog"
                    :modal="true"
                    :close-on-click-modal="false"
                    :close-on-press-escape="false"
                    :center="true"
                    :title="this.$t('App.view.customer.title_add_address')"
                    :visible.sync="pageData.addReceiptDialogVisible"
                  >
                    <el-form
                      :model="formData.newReceipt"
                      ref="form_newReceipt"
                      class="form_newReceipt"
                      size="mini"
                    >
                      <el-form-item
                        :label="this.$t('App.view.customer.label_country')"
                      >
                        <el-col>
                          <el-select
                            v-model="formData.newReceipt.country"
                            filterable
                            size="small"
                            style="width: 100%"
                            :placeholder="$t('App.text.placeholder_select')"
                          >
                            <div v-if="pageData.lang == 'cn'">
                              <el-option
                                v-for="(item, index) in pageData.countryList"
                                :key="index"
                                :label="item.name_cn"
                                :value="item.id"
                              ></el-option>
                            </div>
                            <div v-else>
                              <el-option
                                v-for="(item, index) in pageData.countryList"
                                :key="index"
                                :label="item.name_en"
                                :value="item.id"
                              ></el-option>
                            </div>
                          </el-select>
                        </el-col>
                      </el-form-item>

                      <el-form-item
                        :label="this.$t('App.view.customer.label_province')"
                      >
                        <el-input
                          v-model="formData.newReceipt.province"
                          maxlength="20"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        :label="this.$t('App.view.customer.label_city')"
                      >
                        <el-input
                          v-model="formData.newReceipt.city"
                          maxlength="50"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        :label="this.$t('App.view.customer.label_address')"
                      >
                        <el-input
                          v-model="formData.newReceipt.address"
                          maxlength="50"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        :label="this.$t('App.view.customer.label_zipcode')"
                      >
                        <el-input
                          v-model="formData.newReceipt.zipcode"
                          maxlength="20"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        :label="this.$t('App.view.customer.label_contacts')"
                      >
                        <el-input
                          v-model="formData.newReceipt.contacts"
                          maxlength="30"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        :label="this.$t('App.view.customer.label_company')"
                      >
                        <el-input
                          v-model="formData.newReceipt.company"
                          maxlength="100"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        :label="this.$t('App.view.customer.label_add_tel')"
                      >
                        <el-input
                          v-model="formData.newReceipt.tel"
                          maxlength="30"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        :label="this.$t('App.view.customer.label_add_email')"
                      >
                        <el-input
                          v-model="formData.newReceipt.email"
                          maxlength="100"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        :label="this.$t('App.view.customer.label_taxno')"
                      >
                        <el-input
                          v-model="formData.newReceipt.taxno"
                          maxlength="15"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        :label="this.$t('App.view.customer.label_tag')"
                      >
                        <el-input
                          v-model="formData.newReceipt.tag"
                          maxlength="13"
                          show-word-limit
                          size="mini"
                          :placeholder="
                            $t('App.text.placeholder_tag_shippingadd')
                          "
                        ></el-input>
                      </el-form-item>

                      <el-form-item>
                        <el-button
                          class="addAddressBtn"
                          type="success"
                          size="mini"
                          @click="useJsDoNewReceipt(formData.newReceipt)"
                        >
                          {{ $t("App.view.customer.btn_save") }}</el-button
                        >
                      </el-form-item>
                    </el-form>
                  </el-dialog>

                  <el-dialog
                    width="30%"
                    ref="editReceipt_Dialog"
                    :modal="true"
                    :close-on-click-modal="false"
                    :close-on-press-escape="false"
                    :center="true"
                    :title="this.$t('App.view.customer.title_edit_address')"
                    :visible.sync="pageData.editReceiptDialogVisible"
                  >
                    <el-form
                      :model="formData.editReceipt"
                      ref="form_editReceipt"
                      class="form_editReceipt"
                      size="mini"
                    >
                      <el-form-item
                        :label="this.$t('App.view.customer.label_country')"
                      >
                        <el-col>
                          <el-select
                            v-model="formData.editReceipt.country"
                            filterable
                            size="small"
                            style="width: 100%"
                            :placeholder="$t('App.text.placeholder_select')"
                          >
                            <div v-if="pageData.lang == 'cn'">
                              <el-option
                                v-for="(item, index) in pageData.countryList"
                                :key="index"
                                :label="item.name_cn"
                                :value="item.id"
                              ></el-option>
                            </div>
                            <div v-else>
                              <el-option
                                v-for="(item, index) in pageData.countryList"
                                :key="index"
                                :label="item.name_en"
                                :value="item.id"
                              ></el-option>
                            </div>
                          </el-select>
                        </el-col>
                      </el-form-item>

                      <el-form-item
                        :label="this.$t('App.view.customer.label_province')"
                      >
                        <el-input
                          v-model="formData.editReceipt.province"
                          maxlength="20"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        :label="this.$t('App.view.customer.label_city')"
                      >
                        <el-input
                          v-model="formData.editReceipt.city"
                          maxlength="50"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        :label="this.$t('App.view.customer.label_address')"
                      >
                        <el-input
                          v-model="formData.editReceipt.address"
                          maxlength="50"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        :label="this.$t('App.view.customer.label_zipcode')"
                      >
                        <el-input
                          v-model="formData.editReceipt.zipcode"
                          maxlength="20"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        :label="this.$t('App.view.customer.label_contacts')"
                      >
                        <el-input
                          v-model="formData.editReceipt.contacts"
                          maxlength="30"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        :label="this.$t('App.view.customer.label_company')"
                      >
                        <el-input
                          v-model="formData.editReceipt.company"
                          maxlength="100"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        :label="this.$t('App.view.customer.label_add_tel')"
                      >
                        <el-input
                          v-model="formData.editReceipt.tel"
                          maxlength="30"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        :label="this.$t('App.view.customer.label_add_email')"
                      >
                        <el-input
                          v-model="formData.editReceipt.email"
                          maxlength="100"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        :label="this.$t('App.view.customer.label_taxno')"
                      >
                        <el-input
                          v-model="formData.editReceipt.taxno"
                          maxlength="15"
                          show-word-limit
                          size="mini"
                          :placeholder="$t('App.text.placeholder')"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        :label="this.$t('App.view.customer.label_tag')"
                      >
                        <el-input
                          v-model="formData.editReceipt.tag"
                          maxlength="13"
                          show-word-limit
                          size="mini"
                          :placeholder="
                            $t('App.text.placeholder_tag_shippingadd')
                          "
                        ></el-input>
                      </el-form-item>

                      <el-form-item>
                        <el-button
                          class="addAddressBtn"
                          type="success"
                          size="mini"
                          @click="useJsDoEditReceipt(formData.editReceipt)"
                          :loading="pageData.doEditReceiptLoad"
                        >
                          {{ $t("App.view.customer.btn_save") }}</el-button
                        >
                      </el-form-item>
                    </el-form>
                  </el-dialog>
                </div>

                <div v-if="pageData.receiptList.length > 0">
                  <div
                    v-for="(address, index) in pageData.receiptList"
                    :key="index"
                    class="div_address"
                  >
                    <el-button
                      circle
                      type="danger"
                      class="el-icon-minus"
                      size="mini"
                      @click="useJsDeleteReceipt(address)"
                    ></el-button>
                    <el-button
                      circle
                      type="primary"
                      class="el-icon-edit"
                      size="mini"
                      @click="editReceipt(address)"
                    ></el-button>
                    &nbsp;&nbsp;&nbsp;
                    <el-tag
                      size="medium"
                      type="warning"
                      effect="dark"
                      :hit="true"
                      >{{ address.tag }}</el-tag
                    >
                    {{
                      address.contacts +
                      ", " +
                      address.company +
                      "," +
                      address.email +
                      ", " +
                      address.tel +
                      ", " +
                      address.address +
                      ", " +
                      address.city +
                      ", " +
                      address.province +
                      ", " +
                      address.zipcode +
                      ", " +
                      address.taxno
                    }}
                  </div>
                </div>
                <div v-else style="text-align: center; margin-top: 3rem">
                  <i class="el-icon-folder-opened" style="font-size: 4rem"></i>
                  <el-col
                    style="
                      margin-top: 1.5rem;
                      font-size: 1.3rem;
                      margin-bottom: 2rem;
                      color: #606266;
                    "
                    >{{ this.$t("App.page.center.empty_address") }}</el-col
                  >
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <div class="foot_wrap">
          <com-foot></com-foot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue';
import Head from "@/components/customer/customerCommonHeader";
import Foot from "@/components/customer/customerCommonFooter";
import * as centerjs from "@/assets/js/center"
import * as verifyjs from "@/assets/js/verify";
import * as commonjs from '@/assets/js/common';
import * as utilsjs from "@/assets/js/utils";
export default {
  data() {
    return {
      shown: {
        mainshow: false
      },
      pageData: {
        lang: '',
        username: '',
        custUserinfo: {},
        listOrders: [],
        listOrdersBackup: [],
        listOrdersSearch: [],
        listOrders_finished: [],
        listOrders_processing: [],
        orderListDisplay: 1,
        searchContent: '',
        shippingList: [],
        receiptList: [],
        countryList: [],
        oldShipping: '',
        oldReceipt: '',
        doEditShippingLoad: false,
        addShippingDialogVisible: false,
        addReceiptDialogVisible: false,
        editShippingDialogVisible: false,
        editReceiptDialogVisible: false,
        resetPasswordDialogVisible: false,
        oldBasicInfo: {}
      },
      formData: {
        passwordForm: {
          password: ''
        },
        basicInfo: {
          email: '',
          cc_email: {
            email1: '',
            email2: '',
            email3: '',
            email4: '',
            email5: ''
          }
        },
        newShipping: {
          username: '',
          country: '',
          province: '',
          city: '',
          zipcode: '',
          address: '',
          company: '',
          contacts: '',
          tel: '',
          email: '',
          tag: ''
        },
        newReceipt: {
          id: '',
          username: '',
          country: '',
          province: '',
          city: '',
          zipcode: '',
          address: '',
          company: '',
          contacts: '',
          tel: '',
          email: '',
          taxno: '',
          tag: ''
        },
        editShipping: {
          id: '',
          username: '',
          country: '',
          province: '',
          city: '',
          zipcode: '',
          address: '',
          company: '',
          contacts: '',
          tel: '',
          email: '',
          tag: ''
        },
        editReceipt: {
          id: '',
          username: '',
          country: '',
          province: '',
          city: '',
          zipcode: '',
          address: '',
          company: '',
          contacts: '',
          tel: '',
          email: '',
          taxno: '',
          tag: ''
        }
      },
    };
  },
  created() {
    this.$npg.start();
    this.$npg.inc();
  },
  mounted() {
    this.prepareForMounted();
  },
  methods: {
    prepareForMounted() {
      this.$npg.done();
      this.pageData.lang = sessionStorage.getItem('lang');
      this.pageData.username = sessionStorage.getItem('username');
      this.pageData.custUserinfo = JSON.parse(sessionStorage.getItem(this.pageData.username));
      if (verifyjs.isMounted(this)) {
        document.title = this.$t("App.title.center");
        this.pageData.countryList = JSON.parse(sessionStorage.getItem("listCountry"));
        if (this.pageData.countryList.length == 0) {
          this.$notify.error({
            title: this.$t("App.notify.title_server"),
            message: this.$t("App.notify.content_country_null"),
            duration: 0
          });
          setTimeout(() => {
            this.$router.push({ name: 'Login' });
          }, 2000);
          return;
        }
        centerjs.getInfomation(this, this.pageData.username);
        centerjs.getAllOrders(this, this.pageData.username);
        centerjs.getAllShipping(this, this.pageData.username);
        centerjs.getAllReceipt(this, this.pageData.username);
        setTimeout(() => {
          this.shown.mainshow = true;
        }, 1);
      } else {
        this.$router.push({ name: 'Login' });
      }
    },
    switchOrderList(val) {
      this.pageData.orderListDisplay = val;
    },
    toOrderform(order) {
      let orderRouter = this.$router.resolve({
        name: 'Orderform',
        query: {
          orderid: order.id
        }
      });
      window.open(orderRouter.href, '_blank');
    },
    searchOrderAll() {
      this.pageData.listOrdersSearch = [];
      if (verifyjs.strIsEmpty(this.pageData.searchContent)) {
        this.pageData.listOrders = JSON.parse(JSON.stringify(this.pageData.listOrdersBackup));
        return;
      }
      for (let item of this.pageData.listOrdersBackup) {
        if (item.cust_po == null) {
          continue;
        }
        if (item.id.toLowerCase().search(this.pageData.searchContent.toLowerCase()) != -1 ||
          item.fid.toLowerCase().search(this.pageData.searchContent.toLowerCase()) != -1 ||
          item.cust_po.toLowerCase().search(this.pageData.searchContent.toLowerCase()) != -1 ||
          item.create_time.search(this.pageData.searchContent) != -1) {
          this.pageData.listOrdersSearch.push(item);
        }
      }
      this.pageData.listOrders = JSON.parse(JSON.stringify(this.pageData.listOrdersSearch));
    },
    useJsDeleteShipping(shipping) {
      centerjs.deleteShipping(this, shipping.id);
    },
    useJsDeleteReceipt(receipt) {
      centerjs.deleteReceipt(this, receipt.id);
    },
    addShipping() {
      if (this.pageData.shippingList.length > 9) {
        this.$notify.info({
          title: this.$t("App.page.center.notify_title_notification"),
          message: this.$t("App.page.center.notify_full_address")
        });
        return;
      }
      this.pageData.addShippingDialogVisible = true;
    },
    addReceipt() {
      if (this.pageData.receiptList.length > 9) {
        this.$notify.info({
          title: this.$t("App.page.center.notify_title_notification"),
          message: this.$t("App.page.center.notify_full_address")
        });
        return;
      }
      this.pageData.addReceiptDialogVisible = true;
    },
    editShipping(shipping) {
      this.pageData.oldShipping = JSON.parse(JSON.stringify(shipping));
      
      this.formData.editShipping.id = shipping.id;
      this.formData.editShipping.country = shipping.country;
      this.formData.editShipping.province = shipping.province;
      this.formData.editShipping.city = shipping.city;
      this.formData.editShipping.zipcode = shipping.zipcode;
      this.formData.editShipping.address = shipping.address;
      this.formData.editShipping.company = shipping.company;
      this.formData.editShipping.contacts = shipping.contacts;
      this.formData.editShipping.tel = shipping.tel;
      this.formData.editShipping.email = shipping.email;
      this.formData.editShipping.tag = shipping.tag;

      this.pageData.editShippingDialogVisible = true;
    },
    editReceipt(receipt) {
      this.pageData.oldReceipt = JSON.parse(JSON.stringify(receipt));
      
      this.formData.editReceipt.id = receipt.id;
      this.formData.editReceipt.country = receipt.country;
      this.formData.editReceipt.province = receipt.province;
      this.formData.editReceipt.city = receipt.city;
      this.formData.editReceipt.zipcode = receipt.zipcode;
      this.formData.editReceipt.address = receipt.address;
      this.formData.editReceipt.company = receipt.company;
      this.formData.editReceipt.contacts = receipt.contacts;
      this.formData.editReceipt.tel = receipt.tel;
      this.formData.editReceipt.email = receipt.email;
      this.formData.editReceipt.taxno = receipt.taxno;
      this.formData.editReceipt.tag = receipt.tag;

      this.pageData.editReceiptDialogVisible = true;
    },
    useJsDoNewShipping(shipping) {
      centerjs.doNewShipping(this, shipping);
    },
    useJsDoNewReceipt(receipt) {
      centerjs.doNewReceipt(this, receipt);
    },
    useJsDoEditShipping(shipping) {
      centerjs.doEditShipping(this, shipping).then((val) => {
        if (val) {
          centerjs.getAllShipping(this, this.pageData.username);
        }
      });
    },
    useJsDoEditReceipt(receipt) {
      centerjs.doEditReceipt(this, receipt).then((val) => {
        if (val) {
          centerjs.getAllReceipt(this, this.pageData.username);
        }
      });
    },
    resetPassword() {
      this.pageData.resetPasswordDialogVisible = true;
    },
    useJsDoResetPass(formname) {
      centerjs.doResetPass(this, this.formData.passwordForm.password);
    },
    useJsDoModifyBasic(formname) {
      centerjs.doModifyBasic(this, this.formData.basicInfo);
    },
    clickTabs(tab) {
      utilsjs.setProgress1(this);
    },
    copySuccess(e) {
      this.$message({
        type: 'success',
        message: this.$t("App.text.copy_success")
      });
    }
  },
  components: {
    'com-head': Head,
    'com-foot': Foot
  },
};
</script>

<style scoped>
.main_wrap {
  overflow: auto;
  background-color: #ffffff;
  width: 100%;
  height: 100%;
}
.body_wrap {
  margin-top: 3rem;
  width: 100%;
  height: 100%;
  overflow: auto;
}
.menu_tabs {
  overflow: auto;
  height: 47rem;
}
.info_content {
  padding: 1rem;
}
.password_content {
  text-align: left;
}
.basic_content {
  width: 60rem;
  margin-top: 2rem;
  border: 0.1rem #dcdfe6 solid;
  border-radius: 0.5rem;
  padding: 1rem;
}
.form_basicInfo {
  width: 60%;
}
.tab_order_list {
  overflow: auto;
  height: 47rem;
}
.radio_group_orderlist {
  text-align: left;
  margin-left: 3rem;
}
.order_list_class_content {
  overflow: auto;
}
.search_content {
  width: 30rem;
  margin-left: 3rem;
  margin-top: 1rem;
}
.card_order {
  margin-top: 1.5rem;
  margin-left: 3rem;
  width: 40%;
  text-align: left;
  font-size: 0.8rem;
  color: #909399;
  display: table;
}
.card_order_finished {
  margin-top: 1.5rem;
  margin-left: 3rem;
  width: 25vw;
  text-align: left;
  font-size: 0.8rem;
  color: #909399;
  display: table;
  /* background-color: #67c23a; */
  opacity: 0.9;
}
.card_order_processing {
  margin-top: 1.5rem;
  margin-left: 3rem;
  width: 25vw;
  text-align: left;
  font-size: 0.8rem;
  color: #909399;
  display: table;
  /* background-color: #909399; */
  opacity: 0.9;
}
.card_body_content {
  width: 100%;
  display: table-cell;
}
.card_suffix_content {
  width: auto;
  display: table-cell;
  vertical-align: middle;
}
.order_list_content {
  overflow: auto;
}
.radio_group_orderlist {
  margin-bottom: 1rem;
}
.div_address {
  margin-bottom: 1.5rem;
  font-size: 0.9rem;
  text-align: left;
  margin-left: 4rem;
  margin-top: 2rem;
}
.new_address {
  text-align: left;
  margin-left: 4rem;
  margin-top: 1rem;
}
.addAddressBtn {
  float: right;
  margin-top: 1rem;
}
.modifyBasicBtn,
.resetPassBtn {
  float: right;
  margin-top: 1rem;
}
.foot_wrap {
  position: fixed;
  left: 37%;
  bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/customer/Center.vue